import { createSelector } from 'reselect';
import { AppStateType } from 'src/store/appstate.type';
import { WITH_CUSTOMER_SERVICE } from './constants';

const selectCustomerService = (state: AppStateType) => state?.[WITH_CUSTOMER_SERVICE];

export const makeSelectCustomerService = () =>
  createSelector(selectCustomerService, (substate) => substate);
